// @flow
import I18nHelper from 'common/helpers/I18nHelper';
import DataUtils from 'common/utils/DataUtils';

export class ErrorMessageParser {
    static parseI18nPath(path: string): { namespace: string, path: string } {
        const namespace = path.split(':')[0];
        const jsonPath = path.split(':').splice(1).join('.');
        return { namespace, path: jsonPath };
    }

    static getTranslatedContextData(contextData: {
        [string]: string
    }): { [string]: string } {
        const contextDataKeys = Object.keys(contextData);
        return contextDataKeys.reduce((translatedContextData, key) => {
            const value: string = contextData[key];
            if (value.startsWith('$t(')) {
                // contextual data needs translation
                const regex = /\(([^)]+)\)/;
                const matches = regex.exec(value) || [];
                const i18nKey = matches[1];
                const { namespace, path } = ErrorMessageParser.parseI18nPath(
                    i18nKey
                );
                translatedContextData[key] = I18nHelper.translate(
                    namespace,
                    path
                );
            } else {
                // contextual data which doesn't need translation
                translatedContextData[key] = value;
            }
            return translatedContextData;
        }, {});
    }

    static getTranslatedMessage(error): string {
        const { responseCode, contextData } = error;
        if (!responseCode) {
            return error.message;
        }
        const { namespace, path } = ErrorMessageParser.parseI18nPath(
            responseCode
        );

        if (!DataUtils.isEmpty(contextData?.responseCode)) {
            return I18nHelper.translate(
                namespace,
                path,
                ErrorMessageParser.getTranslatedContextData(
                    contextData.responseCode
                )
            );
        } else {
            return I18nHelper.translate(namespace, path);
        }
    }
}
